import Http from '../api/http/';

export default class TrainConfig extends Http {
  constructor() {
    super();
  }
  trainConfig_trainConfigListByPage() {
    return super.post('trainConfig/trainConfigListByPage', ...arguments);
  }
  trainConfig_topOperate() {
    return super.post('trainConfig/topOperate', ...arguments);
  }

  trainConfig_onOffline() {
    return super.post('trainConfig/onOffline', ...arguments);
  }

  trainConfig_delete() {
    return super.post('trainConfig/delete', ...arguments);
  }
  /**
   * 新增培训内容
   * @param {Array} trainConfigAddUpdateDTO -  trainConfigAddUpdateDTO
   */
  trainConfig_addTrainConfig() {
    return super.post('trainConfig/addTrainConfig', ...arguments, {});
  }
  /**
   * p端查看培训内容详情
   * @param {integer} id -  id
   */
  trainConfig_getDetailById() {
    return super.post('trainConfig/getDetailById', ...arguments);
  }

  /**
   * 修改培训内容
   * @param {Array} trainConfigAddUpdateDTO -  trainConfigAddUpdateDTO
   */
  trainConfig_updateTrainConfig() {
    return super.post('trainConfig/updateTrainConfig', ...arguments, {});
  }
  /***
   * 获取分类List
   */
  trainConfig_getCategoryIds() {
    return super.post('trainConfig/getCategoryIds', ...arguments);
  }
  /**
   * 固定排序详情
   * @returns
   */
  trainConfig_detailBySort() {
    return super.post('trainConfig/detailBySort', ...arguments);
  }
  /**
   * 更新固定排序
   * @returns
   */
  trainConfig_addOrUpdateSort() {
    return super.post('trainConfig/addOrUpdateSort', ...arguments);
  }
  /**
   * 内容管理导出
   */
  trainConfig_exportList() {
    return super.post('trainConfig/exportList', ...arguments);
  }
  /**
   * 创建人下拉列表
   */
  trainConfig_userBriefSearchForP() {
    return super.post('trainConfig/userBriefSearchForP', ...arguments);
  }
}
